import {Version} from '@/types/versions';
import {setDoc, generateId, getCollectionRef, getDocRef, getDoc, getCollection, getCollectionRefDesc} from '../libs/firestore';


function getVersions(projectId: string, modelId: string, limit = 20) {
  return getCollectionRefDesc(`projects/${projectId}/models/${modelId}/versions`, 'createdAt', limit);
}

function getVersionsOnce(projectId: string, modelId: string, limit = 20) {
  return getCollection(`projects/${projectId}/models/${modelId}/versions`, 'createdAt', limit);
}

function getVersionSubscription(projectId: string, modelId: string, deploymentId: string) {
  return getDocRef(`projects/${projectId}/models/${modelId}/versions/${deploymentId}`);
}

function getVersionOnce(projectId: string, modelId: string, deploymentId: string) {
  return getDoc(`projects/${projectId}/models/${modelId}/versions/${deploymentId}`);
}

function createVersion(projectId: string, modelId: string, deployment: Version) {
  const id = generateId();
  return setDoc(`projects/${projectId}/models/${modelId}/versions/${id}`, deployment);
}

function updateVersion(projectId: string, modelId: string, id: string, deployment: Partial<Version>) {
  return setDoc(`projects/${projectId}/models/${modelId}/versions/${id}`, deployment, true);
}

export {getVersions, getVersionSubscription, getVersionsOnce, getVersionOnce, createVersion, updateVersion}
